import {
  Add,
  Delete,
  Edit,
  Visibility,
  VisibilityOff,
} from "@mui/icons-material";
import { useState } from "react";
import { useCommentData } from "./CommentDataContext";
import Download from "./Download";
import Upload from "./Upload";
import "./Functionality.css";
import CancelPresentationIcon from "@mui/icons-material/CancelPresentation";
import RectangleOutlinedIcon from "@mui/icons-material/RectangleOutlined";
import Toast from "./Toast";

const Functionality = () => {
  const {
    setisDotMode,
    isDotMode,
    rectangleMode,
    setrectangleMode,
    editable,
    setEditable,
    commentDetails,
    activeTab,
    selectedQuery,
    setSelectedQuery,
    seeAllDots,
    setseeAllDots,
  } = useCommentData();

  const [toastOpen, setToastOpen] = useState(false);
  const [toastMsg, setToastMsg] = useState("");

  const handleDelete = () => {
    if (!selectedQuery) {
      alert("No entry selected to delete");
      return;
    }
    window.canvasEngine.FeatureRenderer.deleteSelectedQuery();
    setSelectedQuery(commentDetails[activeTab].at(-1) || null);
  };

  const markAsResolved = () => {
    if (!selectedQuery) {
      alert("No query selected to mark as resolved");
      return;
    }
    window.canvasEngine.FeatureRenderer.markSelectedQueryAsResolved(
      selectedQuery
    );
    setSelectedQuery((prev) => ({
      ...prev,
      is_resolved: !prev?.is_resolved,
    }));
  };

  return (
    <div className="functionality-container">
      <button
        title="Add entry"
        onClick={() => {
          const willEnterDot = !isDotMode;
          const bool = window.canvasEngine.FeatureRenderer.toggleIsDotMode();
          if (!bool) return;
          setisDotMode((prev) => !prev);
          setrectangleMode(false);
          setEditable(false);
          setseeAllDots(false);
          window.canvasEngine.FeatureRenderer.rectangleMode = false;

          if (willEnterDot) {
            setToastMsg("Click on the canvas to add an entry.");
            setToastOpen(true);
          }
        }}
        className="icon-button"
      >
        <Add className={isDotMode ? "icon-blue" : "icon-gray"} />
      </button>
      <button
        title="Draw Rectangle in selected entry"
        className="icon-button"
        onClick={() => {
          if (!selectedQuery) {
            alert("No entry selected to add rectangle ");
            return;
          }
          setrectangleMode((prev) => !prev);
          window.canvasEngine.FeatureRenderer.toggleIsRectangleMode();
          setisDotMode(false);
          setEditable(false);
        }}
      >
        <RectangleOutlinedIcon
          className={rectangleMode ? "icon-blue" : "icon-gray"}
        />
      </button>
      {/* Delete rectangle */}
      <button
        title="Delete Rectangle of selected entry"
        className="icon-button"
        onClick={() => {
          if (!selectedQuery) {
            alert("No entry selected to delete rectangle");
            return;
          }
          window.canvasEngine.FeatureRenderer.deleteRectangle();
        }}
      >
        <CancelPresentationIcon className={"icon-gray"} />
      </button>
      {/* Edit comment */}
      <button
        title="Edit Comment"
        className="icon-button"
        onClick={() => {
          if (!selectedQuery) {
            alert("No entry selected to add rectangle to");
            return;
          }
          setEditable((prev) => !prev);
          setrectangleMode(false);
          setisDotMode(false);
          window.canvasEngine.FeatureRenderer.toggleIsEditable();
        }}
      >
        <Edit className={editable ? "icon-blue" : "icon-gray"} />
      </button>
      {/* Mark as resolved toggle */}
      <button
        className="checkbox-button"
        title="Mark as Resolved selected entry"
      >
        <label className="checkbox-label">
          <input
            type="checkbox"
            checked={selectedQuery?.is_resolved || false}
            onChange={markAsResolved}
            className="checkbox-input"
          />
          <svg
            className="checkbox-icon"
            s
            fill="none"
            stroke="currentColor"
            strokeWidth="3"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M5 13l4 4L19 7"
            />
          </svg>
        </label>
      </button>
      {/* See all details here */}
      <button
        title="See All Details of active tab"
        className="icon-button"
        onClick={() => {
          setseeAllDots(!seeAllDots);
          window.canvasEngine.FeatureRenderer.toggleSeeAllDots();
          setSelectedQuery(null);
        }}
      >
        {seeAllDots ? (
          <Visibility className="icon-blue" />
        ) : (
          <VisibilityOff className="icon-gray" />
        )}
      </button>
      {/* Download active cell json */}
      <div title="Download in JSON of active cell" className="icon-button">
        <Download />
        {/* Upload json */}
      </div>
      <div title="Upload JSON in an active cell" className="icon-button">
        <Upload />
      </div>
      {/* Delete entry */}
      <button
        onClick={handleDelete}
        className="icon-button"
        title="Delete entry"
      >
        <Delete className="icon-gray" />
      </button>
      {/* Toast */}
      <Toast
        open={toastOpen}
        onClose={() => setToastOpen(false)}
        message={toastMsg}
        severity="info"
      />
    </div>
  );
};

export default Functionality;
